import React, { forwardRef } from "react";
import { Link as RouterLink } from "react-router-dom";

// Listing details are served as full HTML for visitors and search engines alike.
export const Link = forwardRef(function ListingAwareLink({ to, ...props }, ref) {
  return typeof to === "string" && to.startsWith("/listings/")
    ? <a {...props} href={to} ref={ref} />
    : <RouterLink {...props} to={to} ref={ref} />;
});
